var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.topbarDense)?_c('v-flex',{staticClass:"dd-dark",attrs:{"elevation-2":"","xs12":"","d-flex":""}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }